import { createContext, useContext } from 'react';
import { SSOActionsContext } from './SSOActionsContext';
import { MembershipActionsContext } from './MembershipActionsContext';
import { PlayerPortalsActionsContext } from './PlayerPortalsActionsContext';

export const ActionContextType = /*#__PURE__*/ createContext<{
  API: any; // formApi
  FormCTAConfig: any;
}>({
  API: null,
  FormCTAConfig: null,
});

export const useActionContext = () => {
  const ssoContext = useContext(SSOActionsContext);
  const membershipContext = useContext(MembershipActionsContext);
  const playerPortalsContext = useContext(PlayerPortalsActionsContext);

  const context = membershipContext?.API
    ? membershipContext
    : playerPortalsContext?.API
    ? playerPortalsContext
    : ssoContext;

  if (!context || (!context.API && !context.FormCTAConfig)) {
    console.error('ActionContext must be used within a provider.');
    return undefined;
  }

  return context;
};
